import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "image-data-config-viewer" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_image = _resolveComponent("icon-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item.image && _ctx.item.image.publicUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.item.image.publicUrl,
          style: _normalizeStyle({ width: (_ctx.item.width || 80) + 'px', height: (_ctx.item.height || 80) + 'px', objectFit: _ctx.item.objectFit || 'contain', display: 'block' })
        }, null, 12, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "img-placeholder",
          style: _normalizeStyle({ width: (_ctx.item.width || 80) + 'px', height: (_ctx.item.height || 80) + 'px' })
        }, [
          _createVNode(_component_icon_image)
        ], 4))
  ]))
}